import React, { useEffect, useState } from 'react';
import './BackgroundAnimation.css'; // Import styles

const BackgroundAnimation = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth <= 480);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  useEffect(() => {
    const lineContainer = document.querySelector('.running-lines');

    const createLine = () => {
      const line = document.createElement('div');
      line.classList.add('line');
      const size = Math.random() * 100 + 50;
      line.style.width = `${size}px`;
      line.style.top = `${Math.random() * 100}vh`;
      const animationDuration = Math.random() * 5 + 5;
      line.style.animationDuration = `${animationDuration}s`;
      lineContainer.appendChild(line);
      setTimeout(() => {
        line.remove();
      }, animationDuration * 1000);
    };

    const intervalLines = setInterval(createLine, isSmallScreen ? 1500 : 800);

    return () => {
      clearInterval(intervalLines);
    };
  }, [isSmallScreen]);

  return (
    <div className="background">
      {/* Optional SVG paths to simulate circuit traces */}
      <svg
        className="circuit-svg"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <path d="M0 10 H40 V30 H70 V10 H100" />
        <path d="M20 100 V70 H50 V90 H80" />
        <path d="M10 40 H30 V60 H90" />
        <path d="M60 0 V20 H80 V50" />
      </svg>

      <div className="running-lines"></div>
      <div className="letters">KG</div>
    </div>
  );
};

export default BackgroundAnimation;
